var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "no__list-style team__container-wrap",
      class: {
        inactive__team: !_vm.team.active,
        "boss__type-table": _vm.$isBoss(),
        seller___table: _vm.sellersTable,
        "hidden-header-table":
          _vm.$isBoss() && _vm.typeOfTable.typeOfTable == "DetailTeam"
      }
    },
    [
      !_vm.$isSupervisor()
        ? _c("div", { staticClass: "slide__item_head collaborators-width" }, [
            _c(
              "div",
              { staticClass: "collaborators-box" },
              [
                _c(
                  "v-icon",
                  {
                    class: { "open__slide-table": _vm.showTable },
                    on: {
                      click: function($event) {
                        _vm.slideToggle(_vm.team)
                      }
                    }
                  },
                  [_vm._v("icon-ic-arrow-down")]
                ),
                _c("h3", [
                  _c("em", [_vm._v(_vm._s(_vm.team.name))]),
                  _vm.team.active === true
                    ? _c("strong", [
                        _vm._v("Activo "),
                        _c("span", [
                          _vm._v(
                            "- " +
                              _vm._s(_vm.typeItemsTable) +
                              ": " +
                              _vm._s(_vm.team.channels)
                          )
                        ])
                      ])
                    : _c("strong", [_vm._v("Inactivo")])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "collaborators-box__edit" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "slide__item_detail",
                    on: {
                      click: function($event) {
                        _vm.editItem()
                      }
                    }
                  },
                  [_vm._v("EDITAR")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "collaborators-width sellers_collaborators-container",
          staticStyle: { display: "block", overflow: "hidden" },
          style: { height: _vm.showTable ? "auto" : "0" }
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "slide__item-add" }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", flex: "1 auto" } },
                  [
                    _vm.additionButtonVisibility
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "add__new-button mr-3",
                            on: {
                              click: function($event) {
                                _vm.addNewItem(_vm.team)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.additionButton))]
                        )
                      : _vm._e(),
                    _vm.completeFields
                      ? _c(
                          "v-btn",
                          {
                            style: { "ml-4": _vm.additionButtonVisibility },
                            attrs: { outline: "", color: "primary" },
                            on: { click: _vm.downloadData }
                          },
                          [_vm._v("Exportar datos")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm.withSearchBox
                ? _c("search-box", {
                    staticClass: "slide_items-search",
                    staticStyle: { "margin-left": "auto" },
                    attrs: {
                      placeholder: "BUSCAR POR NOMBRE, DOCUMENTO O CANAL"
                    },
                    on: { search: _vm.search },
                    model: {
                      value: _vm.searchTerm,
                      callback: function($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.headers,
                items: _vm.tableData,
                "no-results-text": "No existen coincidencias",
                loading: _vm.tableIsLoading,
                "disable-initial-sort": true,
                "hide-actions": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "headers",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(props.headers[0].text))]),
                        _vm.withCompleteTableFields
                          ? _c("th", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.headers[1].text))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("th", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.headers[2].text))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("th", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.headers[3].text))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("th", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.headers[4].text))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("th", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.headers[5].text))
                            ])
                          : _vm._e(),
                        _c("th", { attrs: { width: "176px" } }, [
                          _vm._v(_vm._s(props.headers[6].text))
                        ])
                      ])
                    ]
                  }
                },
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("tr", { staticClass: "slide__item-content" }, [
                        _c("td", [
                          props.item.supervisor && _vm.showSupervisor
                            ? _c(
                                "h3",
                                {
                                  class: {
                                    "no__edit-supervisor": _vm.editSupervisor
                                  },
                                  staticStyle: { "font-weight": "500" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(props.item.name) + " (supervisor)"
                                  )
                                ]
                              )
                            : _c("h3", [_vm._v(_vm._s(props.item.name))])
                        ]),
                        _vm.withCompleteTableFields
                          ? _c("td", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.item.user))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("td", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.item.documentNumber))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("td", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.item.email))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("td", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.item.channel))
                            ])
                          : _vm._e(),
                        _vm.withCompleteTableFields
                          ? _c("td", { staticClass: "slide__item-row" }, [
                              _vm._v(_vm._s(props.item.subchannel))
                            ])
                          : _vm._e(),
                        _c("td", { attrs: { width: "176px" } }, [
                          _c(
                            "div",
                            { staticClass: "slide__switch" },
                            [
                              _c("v-switch", {
                                attrs: {
                                  disabled:
                                    _vm.$isSupervisor() ||
                                    props.item.supervisor ||
                                    (!_vm.team.active && !_vm.isActiveSwitch)
                                },
                                on: {
                                  change: function($event) {
                                    _vm.status(props.item)
                                  }
                                },
                                model: {
                                  value: props.item.status,
                                  callback: function($$v) {
                                    _vm.$set(props.item, "status", $$v)
                                  },
                                  expression: "props.item.status"
                                }
                              }),
                              props.item.status
                                ? _c("p", [_vm._v("Activo")])
                                : !props.item.status
                                ? _c("p", [_vm._v("Inactivo")])
                                : _vm._e(),
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "background-color": "transparent !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.toDetailTable({
                                        item: props.item,
                                        teamIsActive: _vm.team.active
                                      })
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("icon-ic-pag-right")])],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "no-data" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-xs-center",
                    staticStyle: { padding: "12px 4px" }
                  },
                  [_vm._v("No hay datos disponibles")]
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01930361", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01930361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/slide-item.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-01930361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/slide-item.vue
// module chunks = 4 6 7 8 9